/** What the notification bell knows about its alerts (NOT-007). */
export type BellStatus = "loading" | "error" | "ready";

/** The trigger's accessible name: loading and failure are not "No notifications". */
export function bellLabel(status: BellStatus, count: number): string {
  if (status === "loading") return "Notifications, loading";
  if (status === "error") return "Notifications could not be loaded";
  return count > 0 ? `${count} notifications` : "No notifications";
}
